export default __webpack_public_path__ + "static/media/logo-bca.85cd1c1a.png";